import { Edit } from "iconoir-react";
import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";

export const ModalAcs = ({ sn, contractedService, tokenAcs, wifiNames, cardStyle = false }) => {
    const sessionToken = window.sessionStorage.getItem("token");

    const showWifiModal = async () => {
        const { value: formValues } = await Swal.fire({
            title: "Personalizar Wifi",
            html:
                `<label style="display:block;text-align:left;margin-bottom:0px">Nombre de la red WiFi:</label>` +
                `<input id="swal-ssid" class="swal2-input m-2" placeholder="Nombre de la Red">` +
                `<label style="display:block;text-align:left;margin-bottom:0px;margin-top:15px">Nueva contraseña:</label>` +
                `<input id="swal-pass" type="password" class="swal2-input m-2" placeholder="Nueva contraseña">`,
            showCancelButton: true,
            confirmButtonText: "Guardar",
            confirmButtonColor: "#4a1272",
            focusConfirm: false,
            reverseButtons: true,
            preConfirm: async () => {
                const name_ssid = document.getElementById("swal-ssid").value;
                const pass_ssid = document.getElementById("swal-pass").value;
                const myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${sessionToken}`);
                myHeaders.append("Content-Type", "application/json");

                if (!name_ssid) {
                    Swal.showValidationMessage("Debes ingresar el nombre de la red");
                    return false;
                } else if (!pass_ssid) {
                    Swal.showValidationMessage("Debes ingresar la contraseña");
                    return false;
                }

                try {
                    const cfgBody = {
                        sn: sn,
                        contracted_service: contractedService,
                        token: tokenAcs,
                        name_ssid: name_ssid,
                        pass_ssid: pass_ssid
                    };

                    const cfgResp = await fetch(domain + "/post2venta/wifi/config/", {
                        method: "POST",
                        headers: myHeaders,
                        body: JSON.stringify(cfgBody),
                    });

                    let cfgJson = {};
                    try {
                        cfgJson = await cfgResp.json();
                    } catch (e) {
                        const text = await cfgResp.text().catch(() => "");
                        cfgJson = { msg: text || null };
                    }
                    console.log('Config Response:', cfgResp.status, cfgJson);

                    const backendMsg =
                        cfgJson?.msg ||
                        cfgJson?.message ||
                        cfgJson?.detail ||
                        (cfgJson?.error && (typeof cfgJson.error === "string" ? cfgJson.error : JSON.stringify(cfgJson.error))) ||
                        null;

                    if (cfgResp.ok && (cfgJson.status === 200 || cfgResp.status === 200)) {
                        return { success: true, msg: backendMsg || cfgJson?.msg || "Configuración aplicada" };
                    } else {
                        const msg = backendMsg || `Error ${cfgResp.status}: ${cfgResp.statusText || "Error de conexión al equipo"}`;
                        Swal.showValidationMessage(msg);
                        return false;
                    }
                } catch (err) {
                    Swal.showValidationMessage("Error de conexión al configurar wifi.");
                    return false;
                }
            }
        });

        if (formValues && formValues.success) {
            await Swal.fire("Éxito", formValues.msg || "Wifi configurado correctamente", "success");
            window.location.reload();
        }
    };

    if (cardStyle) {
        return (
            <div
                onClick={showWifiModal}
                className="flex flex-col items-center justify-center gap-2 p-1 bg-white rounded-2xl shadow-sm border border-gray-100 hover:border-colorprimary hover:shadow-md transition-all duration-200 cursor-pointer group min-h-[110px]"
            >
                <div className="bg-purple-50 rounded-xl p-2.5 group-hover:bg-purple-100 transition-colors">
                    <Edit className="w-6 h-6 text-colorprimary" />
                </div>
                <span className="text-md font-medium text-gray-700">Personalizar wifi</span>
            </div>
        );
    }

    return (
        <div onClick={showWifiModal} className="flex items-center gap-2">
            <Edit />
            <span>Personalizar Wifi</span>
        </div>
    );
};